var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          staticClass: "card-box mt14 notice",
          attrs: { "body-style": { padding: "0" } },
        },
        [
          _c("div", { staticClass: "header" }, [
            _c("i", {
              staticClass: "el-icon-arrow-left onHand",
              on: { click: _vm.handleEmit },
            }),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.formData.isEdit ? "修改通知公告" : "添加通知公告")
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { ref: "notice", staticClass: "pl20 mt20" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "input",
                      attrs: { label: "公告标题", prop: "title" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          maxlength: "50",
                          clearable: "",
                          "show-word-limit": "",
                          placeholder: "请输入公告标题",
                        },
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公告分类", prop: "categoryId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "请选择公告分类",
                          },
                          model: {
                            value: _vm.form.categoryId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "categoryId", $$v)
                            },
                            expression: "form.categoryId",
                          },
                        },
                        _vm._l(_vm.formData.optionData, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.cate_name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "input", attrs: { label: "公告简介" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          maxlength: "100",
                          resize: "none",
                          "show-word-limit": "",
                          clearable: "",
                          placeholder: "请输入公告简介",
                        },
                        model: {
                          value: _vm.form.info,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "info", $$v)
                          },
                          expression: "form.info",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "公告封面" } }, [
                    _vm.form.imageUrl
                      ? _c("div", { staticClass: "avatar" }, [
                          _c("img", {
                            staticClass: "img",
                            attrs: { src: _vm.form.imageUrl },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "avatar-upload" }, [
                            _c(
                              "div",
                              { staticClass: "avatar-upload-content" },
                              [
                                _c("i", {
                                  staticClass: "el-icon-zoom-in",
                                  on: { click: _vm.handlePictureCardPreview },
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "el-icon-delete",
                                  on: { click: _vm.handleAvatar },
                                }),
                              ]
                            ),
                          ]),
                        ])
                      : _c("i", {
                          staticClass: "el-icon-plus avatar-uploader-icon",
                          on: { click: _vm.beforeUpload },
                        }),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", [_vm._v(" 建议尺寸: 162X108")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公告正文", prop: "contents" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { width: "65%" } },
                        [
                          _c("ueditorFrom", {
                            ref: "ueditorFrom",
                            attrs: {
                              border: true,
                              height: "500px",
                              content: _vm.form.content,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否置顶" } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.delivery,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "delivery", $$v)
                          },
                          expression: "form.delivery",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "resource-content" },
                    [
                      _c(
                        "el-col",
                        { staticClass: "resource-left" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "发布时间" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { size: "small" },
                                  model: {
                                    value: _vm.form.resource,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "resource", $$v)
                                    },
                                    expression: "form.resource",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "resource",
                                      attrs: { label: 0 },
                                    },
                                    [_vm._v("立即发布")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("定时发布"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { staticClass: "resource-right" },
                        [
                          _c("el-date-picker", {
                            staticClass: "date",
                            attrs: {
                              size: "small",
                              "prefix-icon": "el-icon-date",
                              type: "datetime",
                              "picker-options": _vm.expireTimeOption,
                              clearable: "",
                              placeholder: "选择日期时间",
                            },
                            model: {
                              value: _vm.form.date,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "date", $$v)
                              },
                              expression: "form.date",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cr-bottom-button" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", loading: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.handleConfirm()
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("public.save")) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择图片",
            visible: _vm.dialogVisible,
            width: "850px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("upload-picture", {
            ref: "uploadPicture",
            attrs: { "check-button": true },
            on: { getImage: _vm.getImage },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isImage
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.closeImageViewer,
              "url-list": _vm.srcList,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }